import { z } from 'zod'
import UserOrgEntityDtoSchema from './UserOrgEntityDto'
import { FeatureWithActionsDto } from '../../feature/models/FeatureEditDto'
import { FeatureToggleEnum } from '../../feature-toggle/models/FeatureToggleEnum'
import { UserOrgPermissionEnum } from './UserOrgPermissionEnum'
import { OrgDto } from '../../org/models/OrgDto'
import { RoleDto } from '../../role/models/RoleDto'
import errorMap from '@gap/backend/util/validations/validation-error-map'
import { UserDto } from '../../user/models/UserDto'
import { UserOrgUserType } from './UserOrgUserTypeEnum'

export namespace UserOrgDto {
   export const entitySchema = UserOrgEntityDtoSchema
   export type entity = z.output<typeof UserOrgEntityDtoSchema>

   export const idCompositeSchema = UserOrgEntityDtoSchema.pick({ orgId: true, userId: true })
   export type idComposite = z.output<typeof idCompositeSchema>

   export const createSchema = idCompositeSchema.merge(UserOrgEntityDtoSchema.pick({ roleId: true, inviteSentOn: true, userType: true }))
   export type create = z.output<typeof createSchema>

   export const resendInviteSchema = z.object({
      orgId: OrgDto.entitySchema.shape.id,
      userId: z.string({ errorMap }),
   })
   export type resendInvite = z.output<typeof resendInviteSchema>

   export type Info = {
      orgId: OrgDto.entity['id']
      orgType: OrgDto.entity['orgType']
      roleId: RoleDto.entity['id']
      createdAt: OrgDto.entity['createdAt']
      trialEndDate?: OrgDto.entity['trialEndDate']
      tierName?: OrgDto.entity['tierName']
      tierMaxUsers?: OrgDto.entity['tierMaxUsers']
      chargebee?: OrgDto.entity['chargebee']
      /** The user's seat type. On a team plan it selects which of `chargebee.seatEntitlements` applies to them. */
      userType?: UserOrgUserType
      accountStatus?: OrgDto.entity['accountStatus']
      features: FeatureWithActionsDto[]
      xeroAuthorised: OrgDto.entity['xeroAuthorised']
      xpmName?: OrgDto.entity['xpmName']
      syncVia?: OrgDto.entity['syncVia']
      isDeactivated: boolean
      featureToggles: FeatureToggleEnum[]
      /** Toggles where this org was explicitly listed in onlyForOrgIds (allow-listed) */
      featureToggleOrgIdMatches: FeatureToggleEnum[]
      /** Toggles where this org matched only via releasedToBeta + betaFeaturesOptIn (advisor beta opt-in) */
      featureToggleBetaOptInMatches: FeatureToggleEnum[]
      permissions: UserOrgPermissionEnum[]
      userEmail: UserDto.entity['email']
   }
}
